<template>
    <Agencies></Agencies>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Agencies = defineAsyncComponent(() =>
    import("../../components/Hr/Agencies/Table.vue")
);

export default {
    name: "HR_Agencies", //The name you are in should not equal the name of the component you are importing.
    components: { Agencies, AuthLayout },
};
</script>

<style scoped></style>
